import React, { useEffect, useState } from 'react';
import closeIcon from '../../../public/assets/images/close.png';
import prevIcon from '../../../public/assets/images/prevIcon.png';
import nextIcon from '../../../public/assets/images/nextIcon.png';
import * as PDFJS from 'pdfjs-dist';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.mjs?worker';
PDFJS.GlobalWorkerOptions.workerPort = new pdfWorker();

const getFileType = (url) => {
  const cleanUrl = url.split('?')[0];
  const extension = cleanUrl.split('.').pop().toLowerCase();

  if (extension === 'pdf') return 'pdf';
  if (['png', 'jpg', 'jpeg', 'webp', 'gif', 'bmp'].includes(extension))
    return 'image';

  return 'unknown';
};

const Preview = ({ show, onClose, url }) => {
  if (!show) return null;

  const [pdfPages, setPdfPages] = useState([]);
  const [pdfIndex, setPdfIndex] = useState(0);
  const [imageUrl, setImageUrl] = useState(null);
  const [checkFileType, setCheckFileType] = useState(null);

  const loadPdf = async () => {
    // Handle PDF preview
    try {
      const doc = await PDFJS.getDocument(url).promise;
      const pages = [];

      for (let i = 1; i <= doc.numPages; i++) {
        const page = await doc.getPage(i);
        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = document.createElement('canvas');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const ctx = canvas.getContext('2d');

        await page.render({
          canvasContext: ctx,
          viewport,
        }).promise;
        pages.push(canvas.toDataURL('image/png'));
      }
      setPdfPages(pages);
      setPdfIndex(0);
    } catch (error) {
      console.error('PDF render error:', error);
    }
  };

  useEffect(() => {
    const fileType = getFileType(url);
    setCheckFileType(fileType);
    if (fileType === 'pdf') {
      loadPdf();
    } else if (fileType === 'image') {
      setImageUrl(url);
    }
  }, [url]);

  return (
    <div className="fixed inset-0 bg-disable z-[130] flex justify-center items-center">
      <div
        className="
          bg-white rounded-md p-5
          w-[90vw] sm:w-[80vw] md:w-[70vw] lg:w-[50rem]
          h-[90vh] sm:h-[80vh] md:h-[70vh] lg:h-[80vh]
          max-w-[80rem]
          overflow-auto
          flex flex-col gap-5
        "
      >
        <div className="flex justify-end items-center">
          <img
            src={closeIcon}
            alt="close"
            width={20}
            height={20}
            className="cursor-pointer"
            onClick={onClose}
          />
        </div>
        <div className="flex justify-center items-center w-full h-full">
          {checkFileType === 'image' ? (
            <img
              src={url}
              alt="preview"
              width={100}
              height={100}
              className=""
            />
          ) : null}
          {checkFileType === 'pdf' ? (
            !pdfPages.length ? (
              <div className="flex justify-center items-center">Loading...</div>
            ) : (
              <div>
                <div className="border m-2">
                  <img
                    src={pdfPages[pdfIndex]}
                    alt="pdf page"
                    style={{ border: '1px solid #ccc' }}
                    className='"w-full max-h-[80vh] object-contain'
                  />
                </div>
                <div className="flex justify-center items-center mt-4 p-4">
                  <div className="flex gap-2">
                    <div>
                      <button
                        className={`${pdfIndex === 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        disabled={pdfIndex === 0 ? true : false}
                        onClick={() => {
                          if(pdfIndex === 0) {
                            return  null;
                          } else {
                            setPdfIndex((prev) => prev - 1)
                          }
                        }}
                      >
                        <img src={prevIcon} alt="prev" width={30} height={30} />
                      </button>
                    </div>
                    <div>
                      {pdfIndex}/{pdfPages?.length - 1}
                    </div>
                    <div>
                      <button
                        className={`${pdfIndex >= pdfPages.length - 1  ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        disabled={pdfIndex >= pdfPages.length - 1 ? true : false}
                        onClick={() => {
                          if(pdfIndex >= pdfPages.length - 1) {
                            return  null;
                          } else {
                            setPdfIndex((prev) => prev + 1)
                          }
                        }}
                      >
                        <img src={nextIcon} alt="prev" width={30} height={30} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Preview;
